"use strict";
exports.__esModule = true;
exports.Slides = void 0;
var vue_1 = require("vue");
exports.Slides = vue_1.defineComponent({
    name: 'Slides',
    template: /* html */ "\n        <div class=\"splide__list\"><slot></slot></div>\n    "
});
